import { Redirect } from 'react-router-dom';
import { makeStyles } from '@mui/styles';

import Spinner from 'common/spinner';
import ConciergeDashboard from 'pages/concierge-dashboard';
import SuperAdminDashboard from 'pages/superadmin-dashboard';
import useCurrentUser from 'utils/useCurrentUser';

const useStyles = makeStyles(() => ({
  root: {
    height: '100vh',
  },
}));

export default function LoginRedirect() {
  const classes = useStyles();

  const currentUser = useCurrentUser(true);

  if (!currentUser) {
    return <Spinner className={classes.root} />;
  }

  if (currentUser.isConcierge) {
    return <ConciergeDashboard id={currentUser.id!} />;
  } else if (currentUser.isSuperAdmin) {
    return <SuperAdminDashboard />;
  }

  return <Redirect to={`/home/${currentUser.defaultPortal!.id}/home`} />;
}
